import * as React from 'react';

export const FRWheel = (props: React.SVGProps<SVGEllipseElement>) => (
	<ellipse id="FRWHEEL" stroke="#000" rx={24.24} ry={25.07} transform="matrix(0 1 1 0 387.269 155.538)" {...props} />
);
